import Vue from 'vue'

import {
    MessageEditor,MessageTemplateList
} from 'fe-infrastractures'

Vue.component('MessageEditor', MessageEditor)
Vue.component('MessageTemplateList', MessageTemplateList)